module.exports = __webpack_public_path__ + "static/media/nepal_logo.632c79a3.png";